import { createContext, useContext } from 'react'

/**
 * How a block is being drawn (MYD-500).
 *
 *   live       the editor canvas, the presenter, the presenter view
 *   thumbnail  the slide sorter and the presenter's overview grid, where a
 *              deck of forty slides is forty small copies at once
 *
 * Only blocks that are expensive to draw read this. A live map is a WebGL
 * context, and browsers allow roughly sixteen per page before they start
 * dropping the oldest, so a map block draws a still stand-in when it is a
 * thumbnail. Everything else renders the same either way.
 */
/**
 * - `live`: the editor canvas, the presenter.
 * - `thumbnail`: the sorter and overview, where maps are a still stand-in.
 * - `capture`: drawn off-screen to be captured as an image for a published
 *   snapshot (MYD-508). Maps use the street basemap, whatever the block says
 *   (satellite imagery is never stored), and keep their drawing buffer so the
 *   canvas can be read back.
 */
export type BlockRenderMode = 'live' | 'thumbnail' | 'capture'

const BlockRenderModeContext = createContext<BlockRenderMode>('live')

export const BlockRenderModeProvider = BlockRenderModeContext.Provider

export const useBlockRenderMode = () => useContext(BlockRenderModeContext)
